import React from 'react';

const LoadingAnimationSimple = () => {
  return (
    <>
      <div className="fuselight-v5-loading-animation-simple">
        <div className="fuselight-loading-lights">
          <div className="light light-one"></div>
          <div className="light light-two"></div>
          <div className="light light-three"></div>
        </div>
      </div>
    </>
  );
};

export default LoadingAnimationSimple;
